// Version : 0.0.2
// Author : SATHISH
// LastEdit : NANDHAKUMAR
// LastAdd : ADD LOGIN DATA GENERAL COMPANY ID & CHANGED BY USER ID IN EXPORT FUNCTION
// MODFIED DATE: 5/12/2025
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import {
	getChangeMeetingDetailsFailure,
	getChangeMeetingDetailsResponseChanged,
	getChangeMeetingDetailsSuccess,
} from './change-meeting-report.action';
import ChangeMeetingActionTypes from './change-meeting-report.type';
import { changeMeetingListGet } from './change-meeting-report.service';

/** ***************** GET CHANGE MEETING DETAILS START *********************** */
export function* getChangeMeetingList({ payload }: any) {
	try {
		const { companyID, branchID, centerID, databaseName, fromDate, toDate, searchDateType } =
			payload;
		const key = 'GetChangeMeetingReportKey';
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			CenterID: centerID,
			DatabaseName: databaseName,
			FromDate: fromDate,
			ToDate: toDate,
			SearchType: searchDateType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(changeMeetingListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getChangeMeetingDetailsFailure(responseData.data));
		} else {
			yield put(getChangeMeetingDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getChangeMeetingDetailsFailure(error));
	}
}

export function* resetGetChangeMeetingListResponse() {
	yield put(getChangeMeetingDetailsResponseChanged());
}

export function* onGetChangeMeetingListDetails() {
	yield takeLatest(ChangeMeetingActionTypes.GET_CHANGE_MEETING_LIST_START, getChangeMeetingList);
}

export function* onGetChangeMeetingListResponseReset() {
	yield takeLatest(
		ChangeMeetingActionTypes.GET_CHANGE_MEETING_LIST_RESPONSE_RESET,
		resetGetChangeMeetingListResponse,
	);
}
/** ***************** GET CHANGE MEETING DETAILS END *********************** */

export function* reportChangeMeetingSaga() {
	yield all([call(onGetChangeMeetingListDetails), call(onGetChangeMeetingListResponseReset)]);
}
